'use client';

import { useState } from 'react';

import { IoClose } from 'react-icons/io5';

import { Button } from '../button';
import { Dialog, DialogContent, DialogTrigger } from '../dialog';
import { ActionDialogButtons } from '../dialog/layout/ActionDialogButtons';
import { ActionDialogContent } from '../dialog/layout/ActionDialogContent';
import { IconButton } from '../icon-button';

type CloseButtonProps = {
  closeConfirmation?: boolean;
  confirmationMessage?: string;
  confirmationSubtitle?: string;
  /**
   * What leaving the assessment does, and so what the close confirmation offers:
   * exit outright, pause first, or nothing at all — leaving discarding as the only
   * way out.
   */
  closeAction?: 'exit' | 'pause-and-exit' | 'none';
  /** Offers throwing the attempt away, as a third choice in the close confirmation. */
  onDiscard?: () => void;
  onClose: () => void;
};

function CloseButton({
  closeConfirmation,
  confirmationMessage,
  confirmationSubtitle,
  closeAction = 'exit',
  onDiscard,
  onClose,
}: CloseButtonProps) {
  const [open, setOpen] = useState(false);

  if (!closeConfirmation) {
    return (
      <IconButton icon={<IoClose />} aria-label="Cerrar" onClick={onClose} />
    );
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild={true}>
        <IconButton
          icon={<IoClose />}
          aria-label="Cerrar"
          onClick={() => setOpen((v) => !v)}
        />
      </DialogTrigger>
      <DialogContent>
        <ActionDialogContent
          title={confirmationMessage ?? '¿Estás segurx que deseas salir?'}
          subtitle={confirmationSubtitle}
        >
          <ActionDialogButtons>
            {closeAction !== 'none' && (
              <Button
                variant={onDiscard ? 'outline-primary' : 'danger'}
                onClick={() => {
                  setOpen((v) => !v);
                  onClose();
                }}
              >
                {closeAction === 'pause-and-exit' ? 'Pausar y salir' : 'Salir'}
              </Button>
            )}
            {onDiscard && (
              <Button
                variant="danger"
                onClick={() => {
                  setOpen((v) => !v);
                  onDiscard();
                }}
              >
                Descartar
              </Button>
            )}
          </ActionDialogButtons>
        </ActionDialogContent>
      </DialogContent>
    </Dialog>
  );
}

export { CloseButton };
export type { CloseButtonProps };
